import { createStyles, makeStyles } from '@material-ui/styles'
import { BackgroundPositionEnum } from './Image'

export type IBackGroundSize = 'stretch' | 'preserve-ratio' | 'crop' | 'contain'

interface IStylesProps {
  backgroundUrl: string
  backgroundSize: IBackGroundSize
  backgroundPosition: BackgroundPositionEnum
  ratio?: number
  height?: string
}

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      backgroundImage: ({ backgroundUrl }: IStylesProps) => `url(${backgroundUrl})`,
      width: ({ ratio, height }) => {
        const hasHeight = typeof height !== 'undefined'
        const hasRatio = typeof ratio !== 'undefined'
        return !hasHeight || !hasRatio ? '100%' : `calc(${ratio} * ${height})`
      },
      backgroundPosition: 'center',
      backgroundSize: ({ backgroundSize }: IStylesProps) => {
        const choiceSize = {
          'preserve-ratio': 'contain',
          stretch: '100% 100%',
          crop: 'cover',
          contain: 'contain'
        }
        return choiceSize[backgroundSize]
      },
      backgroundPositionX: ({ backgroundSize }: IStylesProps) => {
        switch (backgroundSize) {
          case 'contain':
            return '100%'
          // to keep if we need to reuse for another img
          // case 'crop':
          //   return '50%'
          // default:
          //   return '0%'
        }
      },
      backgroundPositionY: ({ backgroundPosition }: IStylesProps) => backgroundPosition,
      backgroundRepeat: 'no-repeat',
      paddingTop: ({ ratio, height }) => {
        const hasHeight = typeof height !== 'undefined'
        const realRatio = typeof ratio !== 'undefined' ? ratio : 1
        return !hasHeight ? `${100 / realRatio}%` : height
      }
    }
  })
)
